import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";
import { Table } from "react-bootstrap";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useParams, useSearchParams } from "react-router-dom";
import useAppStore from "../../../store/global";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import axios from "axios";
import { useGetAllCategories } from "../../Classification/api";
import { findTitleById } from "../../Classification/utils";
const flattenCategories = (categories, level = 0) => {
  return categories?.reduce((acc, category) => {
    acc.push({ id: category.id, name: category.name, level });

    if (category.children && category.children.length > 0) {
      acc = acc.concat(flattenCategories(category.children, level + 1));
    }
    if (category.jobs && category.jobs.length > 0) {
      acc = acc.concat(flattenCategories(category.jobs, level + 1));
    }
    return acc;
  }, []);
};

export default function SalesTable() {
  const { categoryWiseSales, hasGiftCardIssue, serviceRevenue } =
    useSalesReceiptStore();
  const { id } = useParams();
  const { data: categories, isLoading: categoriesLoading } =
    useGetAllCategories({ restaurantId: id });
  const [searchParams] = useSearchParams();
  const { setDateRange } = useAppStore();
  const [clickBaconCoa, setClickBaconCoa] = useState([]);
  const [baconLoading, setBaconLoading] = useState(false);
  useEffect(() => {
    const fetchClickBaconCoa = async (id) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_CLICKBACON_URL}/backend/utils/categories`,
          {
            restaurantId: id
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CLICKBACON_TOKEN}`
            }
          }
        );

        let cats = response?.data?.data;
        setClickBaconCoa(cats.salesCategories);
        setBaconLoading(false);
      } catch (error) {}
    };
    fetchClickBaconCoa(id);
  }, []);

  const date = searchParams.get("date");
  if (categoryWiseSales.length === 0) {
    return null;
  }
  const handleSeeReport = () => {
    let updatedDate = new Date(date);
    updatedDate.setUTCHours(18, 30, 0, 0);
    updatedDate.setDate(updatedDate.getDate() - 1);
    const updatedDateRange = [
      {
        startDate: updatedDate.toISOString(),
        endDate: updatedDate.toISOString(),
        key: "selection"
      }
    ];
    setDateRange(updatedDateRange);
    window.open(
      `/restaurants/${id}/pmix-reports/`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  function calculateTotal(categoryWiseSales, serviceRevenue) {
    const totalRevenue =
      categoryWiseSales
        .filter((x) => x.category !== "Gift Card")
        .reduce((acc, item) => {
          const grossAmount = item["Gross Amount"]
            ? parseFloat(item["Gross Amount"])
            : 0;
          const refund = item["Refund"] ? parseFloat(item["Refund"]) : 0;
          return acc + grossAmount - refund;
        }, 0) +
      serviceRevenue.reduce(
        (acc, item) => acc + parseFloat(item["service_revenue_amount"]),
        0
      );

    return totalRevenue.toFixed(2);
  }

  return (
    <div className="mx-3">
      <div className="d-flex mb-0 justify-content-end">
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip-category-wise-sale`}>
              {hasGiftCardIssue ? "Gift Card Issue" : "View Report"}
            </Tooltip>
          }
        >
          <p
            className={
              "fs-32 mx-3 my-1" +
              (hasGiftCardIssue ? " text-danger" : "text-muted")
            }
            onClick={handleSeeReport}
            style={{ cursor: "pointer" }}
          >
            <ExclamationCircleFill className="mx-2" />
            See Report
          </p>
        </OverlayTrigger>
      </div>
      <Table hover responsive className="receipt-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Total Amount</th>
            <th>Refund</th>
            <th>Net Amount</th>
          </tr>
        </thead>
        <tbody>
          {categoryWiseSales

            ?.filter((x) => x.category !== "Gift Card")
            ?.map((item, index) => (
              <>
                <tr key={index}>
                  <td
                    style={
                      item.category === "Total" ? { fontWeight: "bold" } : {}
                    }
                  >
                    {categoriesLoading
                      ? item.category
                      : findTitleById(
                          categories?.categories?.filter(
                            (item) => item.type === "Menu"
                          ),
                          item.category
                        )}
                  </td>
                  <td
                    style={
                      item.Category === "Total" ? { fontWeight: "bold" } : {}
                    }
                  >
                    {item["Gross Amount"] !== ""
                      ? item["Gross Amount"].toFixed(2)
                      : "N/A"}
                  </td>
                  <td
                    style={
                      item.Category === "Total" ? { fontWeight: "bold" } : {}
                    }
                  >
                    {item["Refund"] !== "" ? item["Refund"].toFixed(2) : "N/A"}
                  </td>
                  <td
                    style={
                      item.Category === "Total" ? { fontWeight: "bold" } : {}
                    }
                  >
                    {item["Net Amount"] !== ""
                      ? (
                          item["Gross Amount"].toFixed(2) -
                          item["Refund"].toFixed(2)
                        ).toFixed(2)
                      : "N/A"}
                  </td>
                </tr>
                {item?.children &&
                  item?.children?.map((child, i) => (
                    <tr key={i}>
                      <td
                        className="text-muted"
                        style={{ paddingLeft: "30px" }}
                      >
                        {categoriesLoading
                          ? child.category
                          : findTitleById(
                              categories?.categories?.filter(
                                (item) => item.type === "Menu"
                              ),
                              child.category
                            )}
                      </td>
                      <td
                        className="text-muted"
                        style={{ paddingLeft: "30px" }}
                      >
                        {child["Gross Amount"].toFixed(2)}
                      </td>
                      <td
                        className="text-muted"
                        style={{ paddingLeft: "30px" }}
                      >
                        {child["Refund"].toFixed(2)}
                      </td>
                      <td
                        className="text-muted"
                        style={{ paddingLeft: "30px" }}
                      >
                        {child["Net Amount"] !== ""
                          ? (
                              child["Gross Amount"].toFixed(2) -
                              child["Refund"].toFixed(2)
                            ).toFixed(2)
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
              </>
            ))}
          {serviceRevenue?.map((item, index) => (
            <>
              <tr key={index}>
                <td
                  colSpan={3}
                  className="bg-body-tertiary"
                  style={{ fontWeight: "bold" }}
                >
                  Service Revenue {item["service_revenue_total"]}
                </td>
                <td className="bg-body-tertiary" style={{ fontWeight: "bold" }}>
                  {item["service_revenue_amount"]}
                </td>
              </tr>
            </>
          ))}
          <tr>
            <td style={{ fontWeight: "bold" }}>Total</td>
            <td style={{ fontWeight: "bold" }}>
              {categoryWiseSales
                ?.filter((x) => x.category !== "Gift Card")
                ?.reduce(
                  (acc, item) =>
                    acc +
                    (item["Gross Amount"] !== "" ? item["Gross Amount"] : 0),
                  0
                )
                .toFixed(2)}
            </td>
            <td style={{ fontWeight: "bold" }}>
              {categoryWiseSales
                ?.filter((x) => x.category !== "Gift Card")
                ?.reduce(
                  (acc, item) =>
                    acc + (item["Refund"] !== "" ? item["Refund"] : 0),
                  0
                )
                .toFixed(2)}
            </td>
            <td style={{ fontWeight: "bold" }}>
              {calculateTotal(categoryWiseSales, serviceRevenue)}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
